"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSelectInput = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var merge_refs_1 = require("../_util/merge-refs");
var input_1 = require("../input");
var call_both_1 = require("../_util/call-both");
var noop_1 = require("../_util/noop");
exports.TagSelectInput = react_1.forwardRef(function TagSelectInput(_a, ref) {
    var value = _a.value, maxWidth = _a.maxWidth, _b = _a.reservedWidth, reservedWidth = _b === void 0 ? 6 : _b, _c = _a.placeholder, placeholder = _c === void 0 ? "" : _c, _d = _a.style, style = _d === void 0 ? {} : _d, _e = _a.onInput, onInput = _e === void 0 ? noop_1.noop : _e, props = tslib_1.__rest(_a, ["value", "maxWidth", "reservedWidth", "placeholder", "style", "onInput"]);
    var inputRef = react_1.useRef(null);
    var mirrorRef = react_1.useRef(null);
    var _f = tslib_1.__read(react_1.useState(0), 2), width = _f[0], setWidth = _f[1];
    var _g = tslib_1.__read(react_1.useState(value), 2), fullInputValue = _g[0], setFullInputValue = _g[1];
    react_1.useEffect(function () {
        setFullInputValue(value);
    }, [value]);
    react_1.useEffect(function () {
        mirrorRef.current.innerText = fullInputValue || placeholder || "";
        var width = mirrorRef.current.clientWidth;
        setWidth(width > maxWidth ? maxWidth : width);
    }, [fullInputValue, maxWidth, placeholder]);
    var handleInput = function (e) { return setFullInputValue(e.currentTarget.value); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(input_1.Input, tslib_1.__assign({}, props, { value: value, placeholder: placeholder, onInput: call_both_1.callBoth(handleInput, onInput), style: tslib_1.__assign(tslib_1.__assign({}, style), { width: width + reservedWidth }), ref: merge_refs_1.mergeRefs(ref, inputRef) })),
        react_1.default.createElement("span", { ref: mirrorRef, style: {
                position: "absolute",
                top: -9999,
                left: 0,
                whiteSpace: "pre",
                fontSize: 12,
            } })));
});
exports.TagSelectInput.displayName = "TagSelectInput";
//# sourceMappingURL=TagSelectInput.js.map